import { AddIcon } from '../../../../components/buttons/IconButtons';
import CustomTabContainer from '../../../../components/CustomTabContainer';
import CustomTab from '../../../../components/CustomTab';
import UserReservationCards from './UserReservationCards';
import ButtonAction from '../../../../components/buttons/ButtonAction';
import { ReservationAttendancesApp } from '../Functionality/ReservationAttendancesApp';
import AddUserTypeModal from '../Modal/AddUserTypeModal';
import CreateVisitorModal from '../../Visitor/Modal/CreateVisitorModal';
import { STATUS_MODEL } from '../../../../enums/statusEnum';
import UserDetails from "../Modal/UserDetails";
import DeleteModal from "../../../Modals/DeleteModal";
import React from "react";
import {permissionObj} from "../../../../Helpers/permission";
import CopyInvitationLinkModal from "../../Visitor/Invitation/Modal/CopyInvitationLinkModal";
import {MODELS} from "../../../../Apis/Models";
import {toast} from "react-toastify";

/**
 * @Author: Susana García Rodríguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const ReservationAttendances = ({ t, statusId, getInvitationsTab, setModified, selectedTabId,
                                    setSelectedTabId, currentTab, DEV, permission, isOverdue }) => {
    const {
        selected,
        showUserTypeModal,
        setShowUserTypeModal,
        showVisitorModal,
        setShowVisitorModal,
        customTabItems,
        searchElement,
        setSearchElement,
        showUserDetailsModal,
        setShowUserDetailsModal,
        showDeleteModal,
        setShowDeleteModal,
        results,
        userList, setUserList,
        invitationLinkModal,
        setInvitationLinkModal,
        getActionsButtons,
        deleteUser,
        createVisitorInvitation,
        isLimitReached,
        attendeesRef
    } = ReservationAttendancesApp({ statusId, setModified, selectedTabId, DEV, permission, isOverdue });

    return (
        <>
            <div className="border-full-shades-300 border-radius-8px p-16px flex-grow-1 min-h-0 d-flex flex-column">

                <div className='d-flex align-items-center justify-content-end p-3 flex-shrink-0'>
                    {(DEV || permission?.includes(permissionObj?.WEB_EVENT_MANAGE_USERS)) &&
                    statusId !== STATUS_MODEL.CANCELED &&
                    !isOverdue && (
                        <ButtonAction
                            id='btn_ra_create'
                            name='add'
                            className='btn-icon-add'
                            Icon={AddIcon}
                            disabled={isLimitReached}
                            onClick={() => {
                                setShowUserTypeModal(true);
                            }}
                        />
                    )}
                </div>

                <CustomTabContainer
                    activeTab={selectedTabId}
                    setActiveTab={(id) => {
                        setSelectedTabId(id);
                        getInvitationsTab(id);
                        setSearchElement("");
                    }}
                    className={"px-0 border-0"}
                >
                    {customTabItems?.map((item) => (
                        <CustomTab
                            key={item.userTypeId}
                            id={item.userTypeId}
                            title={t(item.translation)}
                            newsNumber={item.total}
                            icon={item.icon}
                            selected={selectedTabId === item.userTypeId}
                        />
                    ))}
                </CustomTabContainer>

                <UserReservationCards
                    t={t}
                    currentTab={currentTab}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    getActionsButtons={getActionsButtons}
                    results={results}
                    attendeesRef={attendeesRef}
                />
            </div>
            {showUserTypeModal && (
                <AddUserTypeModal
                    show={showUserTypeModal}
                    onHide={() => setShowUserTypeModal(false)}
                    activeTab={selectedTabId}
                    showVisitorModal={showVisitorModal}
                    setShowVisitorModal={(value) => {
                        if (value) setShowUserTypeModal(false);
                        setShowVisitorModal(value);
                    }}
                    setModified={setModified}
                    setSearchElement={setSearchElement}
                    userList={userList}
                    setUserList={(list) => {
                        if (results.some(e => list.some(s => s.userId === e.visitorId))) {
                            toast.warning(t("the_user_has_already_been_added"))
                            return;
                        }

                        setUserList(list);
                    }}
                />
            )}
            {showVisitorModal &&
                <CreateVisitorModal
                    title={t('create_visitor')}
                    show={showVisitorModal}
                    onHide={() => setShowVisitorModal(false)}
                    setSelectedList={(visitors) => {
                        createVisitorInvitation(visitors?.[0]);
                    }}
                    selectedList={userList}
                    selectVisitorType={true}
                    moduleId={MODELS.Event}
                />
            }
            { showUserDetailsModal &&
                <UserDetails
                    show={showUserDetailsModal}
                    onHide={() => setShowUserDetailsModal(false)}
                    id={selected}
                    t={t}
                />
            }

            <DeleteModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                data={[selected]}
                onClickFn={() => {
                    deleteUser();
                }}
                title_modal={t('delete')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t("invitation")}
            />

            {invitationLinkModal && selected &&
            <CopyInvitationLinkModal
                show={invitationLinkModal}
                setShow={setInvitationLinkModal}
                itemSelected={selected}
            />
            }
        </>
    );
};

export default ReservationAttendances;
